import { Lesson } from "./Lesson";

export class Quiz {
    questions: IQuestion[];
    dom: HTMLDivElement;
    lesson: Lesson;
    constructor(lesson: Lesson) {
      this.lesson = lesson;
      this.questions = lesson.lesson.Questions || [];
      this.dom = document.createElement("div");
      this.renderQuestions();
    }
  
    renderQuestions() {
      this.dom.innerHTML = ""; // Clear existing DOM elements
      this.questions.forEach((question, questionIndex) => {
        const questionDom = this.createQuestion(question, questionIndex);
        this.dom.appendChild(questionDom);
      });
    }
  
    createQuestion(question: IQuestion, questionIndex: number) {
      const div = document.createElement("div");
      div.classList.add("question","card", "mb-3");
  
      //   <h5 class="card-header">Featured</h5>
      const questionTitle = document.createElement("input");
      questionTitle.placeholder = "Enter a question here...";
      questionTitle.classList.add("form-control", "mb-2");
      questionTitle.style.fontWeight = "bold";
      questionTitle.style.fontSize = "1.2rem";
      questionTitle.type = "text";
      questionTitle.classList.add("card-header");
      questionTitle.value = question.Question;
      questionTitle.addEventListener("input", () => {
        this.questions[questionIndex].Question = questionTitle.value;
      });
      div.appendChild(questionTitle);
  
      this.appendOptions(div, question, questionIndex);
  
      return div;
    }
    appendOptions(
      div: HTMLDivElement,
      question: IQuestion,
      questionIndex: number
    ) {
      const ul = document.createElement("ul");
      ul.classList.add("list-group", "list-group-flush");
      ul.classList.add("options");
  
      question.Options.forEach((option, optionIndex) => {
        const li = document.createElement("li");
        li.classList.add("list-group-item", "d-flex", "justify-content-between");
  
        const textBox = document.createElement("input");
        textBox.placeholder = "Enter an option here...";
        textBox.classList.add("form-control", "me-2");
        textBox.type = "text";
        textBox.value = option.Option;
        textBox.addEventListener("input", () => {
          this.questions[questionIndex].Options[optionIndex].Option =
            textBox.value;
        });
        li.appendChild(textBox);
  
        // Add checkbox for option correctness
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.checked = !!option.IsCorrect; // Convert to boolean
        checkbox.addEventListener("change", () => {
          this.updateCorrectness(questionIndex, optionIndex, checkbox.checked);
        });
        li.appendChild(checkbox);
        ul.appendChild(li);
      });
  
      div.appendChild(ul);
    }
  
    updateCorrectness(
      questionIndex: number,
      optionIndex: number,
      isChecked: boolean
    ) {
      this.questions[questionIndex].Options[optionIndex].IsCorrect = isChecked;
    }
  }
  